module.exports = __webpack_public_path__ + "static/fonts/iconfont.20b4340.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aio-weather/iconfont.eot?t=1558949754896
// module id = 362
// module chunks = 1